export const PURCHASE_CTA_COPY_EXP_NAME = 'pen-4993_v1'
